import { motion } from 'framer-motion';
import { PROCESS } from '../data';

export const Process = () => (
    <section id="process" data-testid="process-section" className="py-24 sm:py-32 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            >
                <p className="font-mono-x text-xs uppercase tracking-[0.3em] text-emerald-400 mb-4">
                    02 — The Manifesto
                </p>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl">
                    From enquiry to disbursal,{' '}
                    <span className="text-slate-500">in four chapters.</span>
                </h2>
            </motion.div>

            <div className="mt-14">
                {PROCESS.map((chapter, i) => (
                    <motion.div
                        key={chapter.step}
                        data-testid={`process-step-${chapter.step}`}
                        initial={{ opacity: 0, x: i % 2 === 0 ? -40 : 40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                        className={`group grid grid-cols-1 md:grid-cols-12 gap-6 py-10 border-t border-white/10 ${
                            i === PROCESS.length - 1 ? 'border-b' : ''
                        }`}
                    >
                        <div className="md:col-span-3">
                            <span className="font-mono-x text-5xl sm:text-6xl font-semibold text-white/10 group-hover:text-emerald-500/60 transition-colors duration-500">
                                {chapter.step}
                            </span>
                        </div>
                        <div className="md:col-span-4">
                            <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight">
                                {chapter.title}
                            </h3>
                        </div>
                        <div className="md:col-span-5">
                            <p className="text-sm sm:text-base leading-relaxed text-slate-400">
                                {chapter.body}
                            </p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
